import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Define a type for the slice state
interface LevelState {
  page: number
}

// Define the initial state using that type
const initialState: LevelState = {
  page: 0,
}

export const levelSlice = createSlice({
  name: 'level',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setCurrentPage: (state, action: PayloadAction<number>) => {
        state.page = action.payload
    },
  }
})

export const { setCurrentPage } = levelSlice.actions

export default levelSlice.reducer